import React, { useState } from 'react';
import axios from 'axios';
import * as API from "../../Endpoints/endpoint";

function UploadInfo() {
  const [formData, setFormData] = useState({
    srno: '',         // Added srno here
    chartname: '',
    language: '',
    religion: '',
    avatar: '',
    voice: '',
    vedio: '',
    mood: '',
    agegroup: '',
    term: '',
  });

  const [qrcodeFile, setQrcodeFile] = useState(null);
  const [photoPdfFile, setPhotoPdfFile] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e, type) => {
    if (type === 'qrcode') setQrcodeFile(e.target.files[0]);
    if (type === 'photopdf') setPhotoPdfFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    Object.keys(formData).forEach(key => data.append(key, formData[key]));
    if (qrcodeFile) data.append('qrcode', qrcodeFile);
    if (photoPdfFile) data.append('photopdf', photoPdfFile);

    try {
      const response = await axios.post(API.POST_QRCODE, data);
      alert(response.data.message);
    } catch (error) {
      console.error(error);
      alert('Error uploading data');
    }
  };

  return (
    <div className="upload-container">
      <h2>Upload QR Info</h2>
      <form onSubmit={handleSubmit} encType="multipart/form-data">

        <h3>Chart Details</h3>

        <label>Sr No</label>
        <input 
          type="number" 
          name="srno" 
          placeholder="Enter Serial Number" 
          onChange={handleChange} 
          required 
        />

        <label>Chart Name</label>
        <input 
          type="text" 
          name="chartname" 
          placeholder="Chart Name" 
          onChange={handleChange} 
          required 
        />

        <h3>Upload QR Code Image</h3>
        <input 
          type="file" 
          accept="image/*" 
          onChange={(e) => handleFileChange(e, 'qrcode')} 
          required 
        />

        <h3>Upload Photo PDF</h3>
        <input 
          type="file" 
          accept="application/pdf" 
          onChange={(e) => handleFileChange(e, 'photopdf')} 
          required 
        />

        <h3>Additional Details</h3>

        <label>Language</label>
        <input type="text" name="language" placeholder="Language" onChange={handleChange} />

        <label>Religion</label>
        <input type="text" name="religion" placeholder="Religion" onChange={handleChange} />

        <label>Avatar</label>
        <input type="text" name="avatar" placeholder="Avatar" onChange={handleChange} />

        <label>Voice</label>
        <input type="text" name="voice" placeholder="Voice" onChange={handleChange} />

        <label>Vedio</label>
        <input type="text" name="vedio" placeholder="Vedio" onChange={handleChange} />

        <label>Mood</label>
        <input type="text" name="mood" placeholder="Mood" onChange={handleChange} />

        <label>Age Group</label>
        <input type="text" name="agegroup" placeholder="Age Group" onChange={handleChange} />

        <label>Term</label>
        <input type="text" name="term" placeholder="Term" onChange={handleChange} />

        <button type="submit">Submit</button>
      </form>
    </div>
  );
}

export default UploadInfo;
